
var members = require("../data/members_ref.json")


function getAllMembers() {
    return(members);
}

function getActiveMembers() {

    var activeMembers = [];
    
    function isActive(member) {
        if(member["active"] === "yes")
        {
            activeMembers.push(member)
        }
    }

    members.forEach(isActive);
    
    return (activeMembers);
}

function getInActiveMembers() {
    var inactiveMembers = [];
    
    function isInactive(member) {
        if(member["active"] !== "yes")
        {
            inactiveMembers.push(member)
        }
    }

    members.forEach(isInactive);
    
    return (inactiveMembers);
}

function getMembersWithRoles() {
    var membersWithRoles = [];

    function hasRole(member){
        if(member["role"])
        {
            membersWithRoles.push(member);
        }
    }

    members.forEach(hasRole);

    return membersWithRoles;
}

function getNotableMembers() {
    var notableMembers = []

    function isNotable(member){
        if(member["notability"]) {
            notableMembers.push(member)
        }
    }
    
    members.forEach(isNotable);

    return notableMembers
}

export {getAllMembers, getActiveMembers, getInActiveMembers, getMembersWithRoles, getNotableMembers};